import { render } from "./TrendChartAnswered.vue?vue&type=template&id=8d6af7d4&scoped=true"
import script from "./TrendChartAnswered.vue?vue&type=script&lang=js"
export * from "./TrendChartAnswered.vue?vue&type=script&lang=js"

import "./TrendChartAnswered.vue?vue&type=style&index=0&id=8d6af7d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6af7d4"]])

export default __exports__